<script>
  import { appSession, appConstants } from "../stores/app.js";

  // resolve stripe config
  export function GetConfig() {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open("GET", $appConstants.apiURLBase + "stripe/config");
      xhr.setRequestHeader("Authorization", "Bearer " + $appSession.authorisationToken);
      xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      xhr.send("");
      xhr.onload = () => {
        try {
          if (xhr.status < 200 || xhr.status >= 300) throw "NetworkError";
          let response = JSON.parse(xhr.response);
          if (response.success != true) throw response.errormessage;
          resolve(response.data);
        } catch (e) {
          reject(e);
        }
      };
      xhr.onerror = () => {
        reject("NetworkError");
      };
    });
  }

  // post a new stripe customer
  export function PostCustomer() {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open("POST", $appConstants.apiURLBase + "stripe/customer");
      xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      xhr.setRequestHeader("Authorization", "Bearer " + $appSession.authorisationToken);
      xhr.send();
      xhr.onload = () => {
        try {
          if (xhr.status < 200 || xhr.status >= 300) throw "NetworkError";
          let response = JSON.parse(xhr.response);
          if (response.success != true) throw response.errormessage;
          resolve(response.customerid);
        } catch (error) {
          reject(error);
        }
      };
      xhr.onerror = () => {
        reject("NetworkError");
      };
    });
  }

  // post a new stripe subscription
  export function PostSubscription(paymentMethodId, priceId, taxRate, trialDays = 0) {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open("POST", $appConstants.apiURLBase + "stripe/subscription");
      xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      xhr.setRequestHeader("Authorization", "Bearer " + $appSession.authorisationToken);
      xhr.send(JSON.stringify({ paymentmethodid: paymentMethodId, priceid: priceId, taxrate: taxRate, trialdays: trialDays }));
      xhr.onload = () => {
        try {
          if (xhr.status < 200 || xhr.status >= 300) throw "NetworkError";
          let response = JSON.parse(xhr.response);
          if (response.success != true) throw response.errormessage;
          resolve(true);
        } catch (error) {
          reject(error);
        }
      };
      xhr.onerror = () => {
        reject("NetworkError");
      };
    });
  }

  // delete current stripe subscription
  export function DeleteSubscription() {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open("DELETE", $appConstants.apiURLBase + "stripe/subscription");
      xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      xhr.setRequestHeader("Authorization", "Bearer " + $appSession.authorisationToken);
      xhr.send();
      xhr.onload = () => {
        try {
          if (xhr.status < 200 || xhr.status >= 300) throw "NetworkError";
          let response = JSON.parse(xhr.response);
          if (response.success != true) throw response.errormessage;
          resolve(true);
        } catch (error) {
          reject(error);
        }
      };
      xhr.onerror = () => {
        reject("NetworkError");
      };
    });
  }

  // post a new credit card
  export function PostCreditcard(paymentMethodId) {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open("POST", $appConstants.apiURLBase + "stripe/creditcard");
      xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      xhr.setRequestHeader("Authorization", "Bearer " + $appSession.authorisationToken);
      xhr.send(JSON.stringify({ paymentmethodid: paymentMethodId }));
      xhr.onload = () => {
        try {
          if (xhr.status < 200 || xhr.status >= 300) throw "NetworkError";
          let response = JSON.parse(xhr.response);
          if (response.success != true) throw response.errormessage;
          resolve(true);
        } catch (error) {
          reject(error);
        }
      };
      xhr.onerror = () => {
        reject("NetworkError");
      };
    });
  }

  // resolve stripe invoices
  export function GetInvoices() {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open("GET", $appConstants.apiURLBase + "stripe/invoices");
      xhr.setRequestHeader("Authorization", "Bearer " + $appSession.authorisationToken);
      xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      xhr.send("");
      xhr.onload = () => {
        try {
          if (xhr.status < 200 || xhr.status >= 300) throw "NetworkError";
          let response = JSON.parse(xhr.response);
          if (response.success != true) throw response.errormessage;
          resolve(response.invoices);
        } catch (e) {
          reject(e);
        }
      };
      xhr.onerror = () => {
        reject("NetworkError");
      };
    });
  }

</script>
